import { TextareaAutosize } from '@material-ui/core'
import { TextField } from '@mui/material'
import { useState } from 'react'
import { memo } from 'react'

const StandardTextField = ({ initialValue, useTextField, change, keyPress, multiline, rows = 1, blur, label }) => {
    const [inputText, setInputText] = useState(initialValue)
    const [descriptionLength, setDescriptionLength] = useState(initialValue.length)
    const displayInput = () => {
        if (useTextField) {
            return (<TextField
                value={inputText}
                onChange={(event) => {
                    const { target } = event
                    setInputText(target.value)
                    setDescriptionLength(target.value.length)
                    change(event)

                }}
                onBlur={(event) => blur ? blur(event) : {}}
                onKeyPress={(event) => keyPress(event)}
                fullWidth
                multiline={multiline}
                maxRows={rows}
                label={`${label} (${descriptionLength} of ${process.env.REACT_APP_MAX_HARMONIZE_MESSAGE_LENGTH} characters)`}
                inputProps={{ maxLength: process.env.REACT_APP_MAX_HARMONIZE_MESSAGE_LENGTH }}
            />)
        } else {
            return (

                <label style={{ display: 'flex', flexDirection: 'column' }}>{`${label} (${descriptionLength} of ${process.env.REACT_APP_MAX_HARMONIZE_MESSAGE_LENGTH} characters)`}
                    <TextareaAutosize
                        value={inputText}
                        onChange={(event) => {
                            const { target } = event
                            setInputText(target.value)
                            setDescriptionLength(target.value.length)
                            change(event)

                        }}
                        onBlur={(event) => blur ? blur(event) : {}}
                        onKeyPress={(event) => keyPress ? keyPress(event) : {}}
                        maxRows={rows}

                    />
                </label>

            )
        }
    }

    return displayInput()
}
export default memo(StandardTextField)